module.exports = __webpack_public_path__ + "static/media/logo_bmw_2020.39b389d3.png";